import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import MediaManager from './../components/MediaManager';
import Tooltips from './../components/Tooltips';


const BUCKET_NAME = 'venkman-assets';
const REGION = 'us-east-1';

const validTypes = [
	'image/jpeg',
	'image/jpg',
	'image/png',
	'image/gif',
	'audio/mp3',
	'video/mp4',
	'video/webm',
	'video/ogg',
];

export default class MediaManagerModel {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.files = null;
		this.s3 = null;
		this.loading = false;
		this.resetForm();
	}

	resetForm(){
		this.search = '';
		this.sortColumn = 'lastModified'
		this.sortAscending = false;
		this.chipFilter = '';
	}

	forceUpdate(){
		this.app.forceUpdate();
	}

	show(mediaType){
		this.chipFilter = mediaType;
		this.app.openFullScreenDialog({label:<span>Manage Media <Tooltips id="manageMedia" /></span>, Component: () => <MediaManager app={this.app} /> })
	}

	setupS3({experimentId, researcherId}){
		const AWS = window.AWS;
		let authentication = this.app.localStorage('authentication');

		AWS.config.update({
			accessKeyId:     authentication.Credentials.AccessKeyId,
			secretAccessKey: authentication.Credentials.SecretKey,
			sessionToken:    authentication.Credentials.SessionToken,
			region: REGION,
		});

		this.s3 = new AWS.S3({
			params:{ 
				Bucket: BUCKET_NAME,
				Delimiter: "/",
				Prefix: `users/${researcherId}/experiments/${experimentId}/assets/`,
			}
		});
	}

	awaitS3(methodName, params = {}){
		return new Promise((resolve, reject) => {
			this.s3[methodName](params, function (err, data) {
				if(err){reject(err); return;}
				// `this` references the AWS.Response instance that represents the response
				resolve({data, response:this});
			});
		});
	}

	async getExperimentAssets(preloadAssets = false){
		let {data, response} = await this.awaitS3('listObjects');
		const href = response.request.httpRequest.endpoint.href;
		const bucketUrl = href + BUCKET_NAME + '/';
		const assets = data.Contents.map((asset) => {

			let app = this.app;

			let file = {
				name: _.last(asset.Key.split('/')),
				type: undefined,
				key:  asset.Key,
				url:  bucketUrl + encodeURIComponent(asset.Key),
				size: asset.Size,
				sizeLabel: this.app.http.formatBytes(asset.Size),
				lastModified: moment(asset.LastModified),
				get id(){
					let mediaSet = app.takeExperimentForm.experiment ? app.liveExperiment.data.mediaSet :  app.experiment.data.mediaSet;
					return mediaSet[this.name] || this.defaultID;
				},
			}

			file.defaultID = file.name.replace(/\.[^/.]+$/, "");
			let extension =  _.last(file.name.toLowerCase().split('.'));
			
			if(['jpg', 'jpeg', 'png', 'gif'].includes(extension)){ file.type = 'image' } 
			if(['mp4', 'ogg', 'webm'].includes(extension)){ file.type = 'video' } 
			if(['mp3'].includes(extension)){ file.type = 'audio' } 

			return file;
		});

		this.files = assets;

		if(preloadAssets){
			await this.preloadAssets();
		}
	}

	async preloadAssets(){
		// We may want to download blobs, and then set directly: http://dinbror.dk/blog/how-to-preload-entire-html5-video-before-play-solved/
		let promises = this.files.map( file => {
			return this.fetchFile(file);
			// return new Promise((resolve, reject) => {
			// 	console.log('adding promises');
				
				

			// 	if(file.type === 'image'){ 
			// 		let image = new Image(); 
			// 		image.onerror = () => { console.log('Failed to load:', file.url); resolve(); };
			// 		image.onload = () => { resolve(); };
			// 		image.src = file.url;
			// 	}
			// 	if(file.type === 'audio'){ 
			// 		let audio = new Audio(); 
			// 		audio.onerror = () => { console.log('Failed to load:', file.url); resolve(); };
			// 		audio.addEventListener('canplaythrough', resolve, false);
			// 		audio.src = file.url; 
			// 	}
			// 	if(file.type === 'video'){
			// 		let video = new Video(); 
			// 		video.onerror = () => { console.log('Failed to load:', file.url); resolve(); };
			// 		video.addEventListener('canplaythrough', resolve, false);
			// 		video.src = file.url; 
			// 	}
			// });
		});
		await Promise.all(promises);

	}

	fetchFile(file){
		return new Promise( (resolve, reject) => {
			var xhrReq = new XMLHttpRequest();
			xhrReq.open('GET', file.url, true);
			xhrReq.responseType = 'blob';

			xhrReq.onload = function() {
				if (this.status === 200) {
					var url = URL.createObjectURL(this.response);
					file.url = url;
					resolve(url);
				}
			}
			xhrReq.onerror = function() {
				console.log('err' ,arguments);
				resolve();
			}
			// xhrReq.onprogress = function(e){
			// 	if(e.lengthComputable) {
			// 		var percentComplete = ((e.loaded/e.total)*100|0) + '%';
			// 		//console.log('progress: ', percentComplete);
			// 	}
			// }
			xhrReq.send();
		});
	}

	get indexedFiles(){
		let indexedFiles = {};
		this.files.forEach(file => indexedFiles[file.id] = file.url );
		return indexedFiles;
	}

	async deleteMedia(file){
		this.loading = true;
		this.forceUpdate();
		await Promise.all([file].map( async file => {
			return this.awaitS3('deleteObject', {Key:file.key});
		}));
		await this.getExperimentAssets();
		this.loading = false;
		this.forceUpdate();
	}

	async uploadAssetFromManager(){
		const fileInput = document.querySelector('.MediaManager-drag-input');
		let errors = false;
		Array.from(fileInput.files).forEach(file=>{
			if(!errors && !validTypes.includes(file.type)){
				alert(`Unsupported file type: ${file.type}. The following formats are supported: \nImages: jpg, png, gif\nAudio: mp3\nVideos: mp4, ogg, webm`);
				errors = true;
			}
		});

		if(errors){return;}

		this.show();
		this.loading = true;
		this.forceUpdate();
		
		await Promise.all(Array.from(fileInput.files).map( async file => {
			return this.uploadToS3({name:file.name, file });
		}));
		fileInput.value='';
		await this.getExperimentAssets();
		this.loading = false;
		this.forceUpdate();
	}

	async uploadToS3({file, name}){
		// err.message
		return await this.awaitS3('upload', {
			Key: this.s3.config.params.Prefix + encodeURIComponent(name),
			Body: file,
			ACL: 'public-read'
		});
	}

}

// function Video(src, append) {
// 	var v = document.createElement("video");
// 	if (src) {
// 	  v.src = src;
// 	}
// 	if (append === true) {
// 	  document.body.appendChild(v);
// 	}
// 	return v;
//   }


// WEBPACK FOOTER //
// ./src/models/MediaManagerModel.js